import styles from './index.module.scss';
import classNames from "classnames";

import { getAbSetting } from "@/helpers/abTesting.ts";

interface SliderProps {
    min: number
    max: number
    onChange: (value: number) => void
    value: number
    suffix?: string
}

export default function Slider ({
    min,
    max,
    onChange,
    value,
    suffix = ''
}: SliderProps) {

    const percentage = ((value - min) / (max - min)) * 100;

    return (
        <div className={styles.slider}>
            <input
                className={styles.input}
                type="range"
                min={min}
                max={max}
                value={value}
                step={1}
                style={{
                    background: `linear-gradient(to right, #0080E2 0%, #0080E2 ${percentage}%, #E2E8F0 ${percentage}%, #E2E8F0 100%)`,
                }}
                onChange={(event) => onChange(Number(event.target.value))}
            />
            <div className={styles.values}>
                <span>{min}{suffix}</span>
                <span>{max}{suffix}</span>
            </div>
        </div>
    );
}
